module.exports = __webpack_public_path__ + "static/media/лесная поляна ночью.bd91e501.png";